import { Table } from "react-bootstrap";

export function ApprovalRequests(props) {
    const getPendingApprovalRequests = () => {
        return props.user.entry_approval_requests.filter((e) => { return e.status === 'PENDING' });
    }

    if (!props.user || !props.user.entry_approval_requests || getPendingApprovalRequests().length === 0) {
        return <></>
    }

    return (
        <>
            <div className="row">
                <div className="column">
                    <h2 className="py-4">Pending Approval Requests</h2>
                    <Table striped bordered hover variant="dark">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Year</th>
                                <th>Entry Amount</th>
                                <th>Overhead Amount</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getPendingApprovalRequests().map(e => {
                                return (
                                    <tr key={e.id}>
                                        <td>{e.status}</td>
                                        <td>{e.year}</td>
                                        <td>{e.entry_amount}</td>
                                        <td>{e.overhead_amount}</td>
                                        <td>{e.description}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    );
}